import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputField from '../../../../Components/Form/components/InputField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import QuestionnaireMultiSelectWithCheckListField from '../../../Questionnaire/Components/QuestionnaireMultiSelectWithCheckList/QuestionnaireMultiSelectWithCheckListField';
import EducationMaterialMultiSelectWithCheckListField from '../../../Base/Components/Inputs/EducationMaterialMultiSelectWithCheckList/EducationMaterialMultiSelectWithCheckListField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import MessageRecipientsMultiSelectWithCheckListField from '../../../Base/Components/Inputs/MessageRecipientsMultiSelectWithCheckList/MessageRecipientsMultiSelectWithCheckListField';
import { MultiSearchWithCheckListValue } from '../../../Base/Components/Inputs/MultiSearchWithCheckList/MultiSearchWithCheckList';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import Loading from '../../../../Components/Loading';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onSuccess: (values: ActionCenterNewMessageFormValues) => void;
	defaultData?: object;
}

export interface ActionCenterNewMessageFormValues {
	subject: string;
	questionnaireIds?: SelectValue[];
	educationMaterialIds?: SelectValue[];
	recipients: MultiSearchWithCheckListValue[];
	content: string;
}

const ActionCenterNewMessageForm: React.FC<Props> = ({
	onSuccess,
	defaultData,
}) => {
	const { t } = useTranslation();

	const validationSchema = yup.object().shape({
		subject: yup
			.string()
			.required(t('validation.actionCenterNewMessageForm.subject')),
		recipients: yup
			.array()
			.required(t('validation.actionCenterNewMessageForm.recipients')),
	});

	const fortMethods = useForm({
		defaultValues: defaultData || {},
		resolver: yupResolver(validationSchema),
	});
	const [isLoading, setIsLoading] = useState(false);

	const handleSuccess = (values: any) => {
		setIsLoading(true);
		onSuccess(values as ActionCenterNewMessageFormValues);
		fortMethods.reset();
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<FormWrapper formMethods={fortMethods}>
			<InputWrapper>
				<InputField
					name='subject'
					label='base.subject'
					placeholder='base.typeMessageSubject'
					isRequired
				/>
			</InputWrapper>
			<InputWrapper>
				<MessageRecipientsMultiSelectWithCheckListField
					name='recipients'
					label='base.toWho'
					placeholder='base.enterNameOrGroup'
					portal
					isRequired
				/>
			</InputWrapper>
			<InputWrapper>
				<QuestionnaireMultiSelectWithCheckListField
					name='questionnaireIds'
					label='base.addQuestionnaire'
					placeholder='base.selectQuestionnaire'
					portal
					isSearchable
				/>
			</InputWrapper>
			<InputWrapper>
				<EducationMaterialMultiSelectWithCheckListField
					name='educationMaterialIds'
					label='base.addEducationalMaterials'
					placeholder='base.selectEducationalMaterials'
					portal
					isSearchable
				/>
			</InputWrapper>
			<InputWrapper>
				<TextAreaField
					name='content'
					label='base.messageContent'
					placeholder='base.messageText'
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSuccess} title='base.sendMessage' />
		</FormWrapper>
	);
};

export default ActionCenterNewMessageForm;
